export default __webpack_public_path__ + "static/media/segre06.5223387b.jpg";